import React from 'react'
import t from '../../../../../translations/main'
import utils from '../../../../../components/Organisms/Form/utils'
import Font from 'src/components/Core/Typography/Font/Font'
import { Trans } from 'react-i18next'
import { RequiredMark } from 'src/components/Atoms/Label/Label.styles'

const InvestorCategoryHeader = (
  <Font key='investorCategoryHeader' ellipsis={false} margin='8px 0 0 0' tag='h4'>
    {t('onboarding.forms.IndividualAccount.InvestmentObjectivesForm.visualOnly.investorCategory.header')}
  </Font>
)

const InvestorCategoryText = (
  <Font key='investorCategory' ellipsis={false} margin='8px 0 0 0'>
    {t('onboarding.forms.IndividualAccount.InvestmentObjectivesForm.visualOnly.investorCategory.content')}
  </Font>
)

const TypeOfInvestmentHeader = (
  <Font key='typeOfInvestmentHeader' ellipsis={false} margin='8px 0 0 0' tag='h4'>
    {t('onboarding.forms.IndividualAccount.InvestmentObjectivesForm.visualOnly.typeOfInvestment.header')}
  </Font>
)

const TypeOfInvestmentText = (
  <Font key='typeOfInvestmentText' ellipsis={false} margin='8px 0 0 0'>
    {/* @ts-ignore-next-line */}
    <Trans i18nKey='onboarding.forms.IndividualAccount.InvestmentObjectivesForm.visualOnly.typeOfInvestment.content' components={{requiredMark: <RequiredMark />}}/>
  </Font>
)

const PleaseIndicate = (
  <Font key='pleaseIndicate' ellipsis={false} margin='8px 0 0 0'>
    {/* @ts-ignore-next-line */}
    <Trans i18nKey='onboarding.forms.IndividualAccount.InvestmentObjectivesForm.visualOnly.pleaseIndicate.content' components={{requiredMark: <RequiredMark />}}/>
  </Font>
)

const config = utils.injectTranslation({
  id: 'InvestmentObjectivesForm',
  path: 'onboarding.forms.IndividualAccount.InvestmentObjectivesForm.inputs',
  content: [
    {
      componentType: 'grid',
      props: {
        alignItems: 'flex-end',
        marginBottom: '32px'
      },
      content: [
        {
          componentType: '',
          visualComponent: InvestorCategoryHeader
        },
        {
          componentType: '',
          visualComponent: InvestorCategoryText
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: '1fr 1fr',
        marginBottom: '32px'
      },
      content: [
        {
          componentType: 'dropdown',
          transformType: 'getValueFromIndex',
          props: {
            name: 'riskProfileCategory',
            removeEllipsis: true,
            utilizeMinWidth: true,
            required: true,
            dontClearValue: true,
            noReset: true
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        alignItems: 'flex-end',
        marginBottom: '12px'
      },
      content: [
        {
          componentType: '',
          visualComponent: TypeOfInvestmentHeader
        },
        {
          componentType: '',
          visualComponent: TypeOfInvestmentText
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(5, fit-content(200px))',
        gridGap: '26px'
      },
      content: [
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'futuresTypeOfInvestment',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'optionsTypeOfInvestment',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'cfdTypeOfInvestment',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'equitiesTypeOfInvestment',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'foreignExchangeTypeOfInvestment',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
      ],
    },
    {
      componentType: 'grid',
      props: {
        alignItems: 'flex-end',
        marginBottom: '12px'
      },
      content: [
        {
          componentType: '',
          visualComponent: PleaseIndicate,
          visualName: 'pleaseIndicate'
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        gridTemplateColumns: 'repeat(6, fit-content(200px))',
        gridGap: '26px'
      },
      content: [
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'financials',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'softCommodities',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'energy',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'preciousMetals',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'baseMetals',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
        {
          componentType: 'checkbox',
          transformType: 'booleanToString',
          props: {
            name: 'other',
            labelProps: {
              labelHeight: 'auto',
              labelMinHeight: '24px',
              labelWhiteSpace: 'pre-wrap',
            },
          },
        },
      ]
    },
    {
      componentType: 'grid',
      props: {
        alignItems: 'flex-end'
      },
      content: [
        {
          componentType: 'input',
          props: {
            name: 'specifyOther',
            isTextarea: true,
            width: '50%',
            rows: '3',
            required: true,
            textAreaHeight: '40px',
            textAreaPointerEvents: 'auto'
          }
        }
      ]
    }
  ],
})

export default config
